import bulmaStyles from "bulma/css/bulma.min.css?inline";

// When bulma stylesheets are imported for multiple components, the
// stylesheets will be duplicated in the distribution folder, causing the
// browser to download similar stylesheets multiple times. To avoid this,
// we provide a single export for the stylesheets, which can be imported
// in multiple components instead.
export const styles = bulmaStyles;
